module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am280-b04c91eb90e22cce2837ab0d2bfb6be9.jpg";